import { COLORS, COLORS_LIST, COMPLEMENTARY_COLORS } from 'Components/utils/color/colors';

export const themes = ({ color }) => {
  const rColor = COLORS_LIST.includes(color) ? color : COLORS.TURQUOISE;

  const thDescriptionBloc = `bg-${rColor} px-5 flex flex-col grow sm:grow-0 justify-center pe-10 rounded-4 text-${COMPLEMENTARY_COLORS[rColor]} w-auto`;
  const thPopinContent = `border-1 border-${rColor} lg:border-0 flex flex-col`;

  return {
    default: {
      thDescriptionBloc,
      thPopinContent: `${thPopinContent} lg:flex-row`,
      thPopinContentImage: 'shrink-0 px-20 pt-20 lg:ps-20 lg:pe-0 lg:py-15',
      thPopinColor: rColor,
      thPopinTextColor: COMPLEMENTARY_COLORS[rColor],
    },
    comparator: {
      thDescriptionBloc: `${thDescriptionBloc} sm:w-full`,
      thPopinContent,
      thPopinContentImage: 'shrink-0 lg:ps-10 lg:py-10 mt-15',
      thPopinColor: rColor,
      thPopinTextColor: COMPLEMENTARY_COLORS[rColor],
    },
  };
};
